/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Userscopenote4Inputs */

const en_settings_reportingapikeys_generate_userscopenote4 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Userscopenote4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys are created per user, never for a whole LP: a key grants exactly the reporting data that the selected user can access, nothing more. To limit which of an LP's data is reachable via the API, pick a user whose access rights match the intended scope.`)
};

/**
* | output |
* | --- |
* | "Keys are created per user, never for a whole LP: a key grants exactly the reporting data that the selected user can access, nothing more. To limit which of a..." |
*
* @param {Settings_Reportingapikeys_Generate_Userscopenote4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_userscopenote4 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Userscopenote4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Userscopenote4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_userscopenote4(inputs)
});
export { settings_reportingapikeys_generate_userscopenote4 as "settings_reportingApiKeys_generate_userScopeNote" }